/*
  aro-collection-in-stock-first.js

  Purpose: keeps `.collection.loading` off during user-initiated filter /
  sort / pagination clicks so the grid doesn't visibly dim during the
  fetch window. The head-inline redirect in layout/theme.liquid handles
  the default-in-stock behaviour for external referrers.

  History: previously ran a two-retrieval assemble path + a path-scoped
  localStorage flag for "user opted out of default" preservation across
  refresh. Removed 2026-09-08 — the flag approach caused a redirect loop
  on some browsers. Refresh-after-untick loses the opt-out; user re-ticks
  to reset default.
*/
(function () {
  'use strict';

  if (!document.body || !document.body.classList.contains('template-collection')) return;

  function whenFacetsReady(cb) {
    if (typeof FacetFiltersForm !== 'undefined') return cb();
    var tries = 0;
    var poll = setInterval(function () {
      if (typeof FacetFiltersForm !== 'undefined') {
        clearInterval(poll);
        cb();
      } else if (++tries > 60) {
        clearInterval(poll);
      }
    }, 50);
  }

  function installFadeTimingWrappers() {
    var origRenderPage = FacetFiltersForm.renderPage;
    if (!origRenderPage || origRenderPage.__aroFadeWrapped) return;
    FacetFiltersForm.renderPage = function (searchParams, event, updateURLHash) {
      var result = origRenderPage.call(this, searchParams, event, updateURLHash);
      var col = document.getElementById('ProductGridContainer');
      col = col && col.querySelector('.collection');
      if (col) col.classList.remove('loading');
      return result;
    };
    FacetFiltersForm.renderPage.__aroFadeWrapped = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { whenFacetsReady(installFadeTimingWrappers); });
  } else {
    whenFacetsReady(installFadeTimingWrappers);
  }
})();
